import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
export var LogLevel =
/*#__PURE__*/
function (_Component) {
  _inherits(LogLevel, _Component);

  function LogLevel() {
    _classCallCheck(this, LogLevel);

    return _possibleConstructorReturn(this, _getPrototypeOf(LogLevel).apply(this, arguments));
  }

  _createClass(LogLevel, [{
    key: "render",
    value: function render() {
      var levelText = LogLevel.levels[this.props.level];
      return React.createElement("span", {
        className: 'loglevel, loglevel_' + this.props.level
      }, levelText);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogLevel;
}(Component);

_defineProperty(LogLevel, "levels", ['Debug', 'Info', 'Warning', 'Error', 'Fatal']);

;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogLevel, "LogLevel", "/srv/http/owncloud/apps/logreader/js/Components/LogLevel.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();